import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import AutoSuggestionsdata from './Autosuggestionsdata'
import Dragdrop from './Dragdrop'
import getFormattedData from './GetFormattedData'
import WikipediaCheckbox from './wikipediaCheckbox'

const ProductionCompany = props => {
  // props for this file from parent
  const { inputData, sendinputdata, name, inputField1, inputField2, weight } = props
  // state variables for this file
  const [ProductionCompanyNames, setProductionCompanynames] = useState([])
  const [ProductionCompanyname, setProductionCompanyname] = useState('')
  const [ProductionCompanynameTelugu, setProductionCompanynameTelugu] = useState('')
  const [filteredProductionCompanyNames, setfilteredProductionCompanyNames] = useState([])
  const [filteredProductionCompanyNamesTelugu, setfilteredProductionCompanyNamesTelugu] = useState(
    [],
  )
  const [searchtrue, setsearchtrue] = useState(true)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [editMode, seteditmode] = useState(true)
  const sendEditmode = data => {
    seteditmode(data)
  }

  const ProductionCompanyEnglish = event => {
    if (event.target.value) {
    setProductionCompanyname(event.target.value)
    } else {
      setsearchtrue(true)
      setProductionCompanynameTelugu('')
      handleProductionCompanynamechange('')
    }
  }

  const sendsearchtrue = data => {
    setsearchtrue(data)
  }

  const ProductionCompanyTelugu = event => {
    setProductionCompanynameTelugu(event.target.value)
  }

  const sendProductionCompanyName = data => {
    setProductionCompanyname(data)
  }

  const sendProductionCompanyNameTelugu = data => {
    setProductionCompanynameTelugu(data)
  }

  const senddata = async (valueOne, valueTwo) => {
    const dataFeilds = { valueOne, valueTwo }
    const field = [inputField1, inputField2]
    const formattedData = await getFormattedData(inputData, dataFeilds, field)
    sendinputdata(formattedData)
  }

  const submitCompany = () => {
    seteditmode(true)
    const CompanyEnglishTemp = [...inputData[inputField1]]
    // console.log(CompanyEnglishTemp)
    const ProductionCompanynameTemp = ProductionCompanyname
    CompanyEnglishTemp.push(ProductionCompanynameTemp)
    const CompanyTeluguTemp = [...inputData[inputField2]]
    const ProductionCompanynamete1 = ProductionCompanynameTelugu
    if (ProductionCompanynamete1.length === 0) {
      const ProductionCompanyfield = `(${ProductionCompanyname})*`
      CompanyTeluguTemp.push(ProductionCompanyfield)
      senddata(CompanyEnglishTemp, CompanyTeluguTemp)
    } else {
      CompanyTeluguTemp.push(ProductionCompanynamete1)
      senddata(CompanyEnglishTemp, CompanyTeluguTemp)
    }

    // on submit setting to intial state
    setProductionCompanyname('')
    setfilteredProductionCompanyNames([])
    setProductionCompanynameTelugu('')
    setsearchtrue(true)
  }

  const ProductionCompanyset = event => {
    const regex = /Create [A-Za-z]+/i
    props.sendBooleanValueChangeDone(`${name}_En`, true)
    if (regex.test(event.target.innerText) === false) {
      const CompanyEnglishTemp = [...inputData[inputField1]]
      CompanyEnglishTemp.push(event.target.innerText)
      // console.log(event.target.innerText)
      const selectedPersonIndex = filteredProductionCompanyNames.findIndex(
        obj => obj.label === event.target.innerText,
      )
      const CompanyTeluguTemp = [...inputData[inputField2]]
      // console.log(filteredProductionCompanyNamesTelugu)
      CompanyTeluguTemp.push(
        filteredProductionCompanyNamesTelugu[selectedPersonIndex].label
          ? filteredProductionCompanyNamesTelugu[selectedPersonIndex].label
          : `(${event.target.innerText})*`,
      )
      const ProductionCompanyNamesTemp = [...ProductionCompanyNames]
      ProductionCompanyNamesTemp.push({
        label: event.target.innerText,
        labelte: filteredProductionCompanyNamesTelugu[selectedPersonIndex].label
          ? filteredProductionCompanyNamesTelugu[selectedPersonIndex].label
          : `(${event.target.innerText})*`,
      })
      // console.log(ProductionCompanyNamesTemp, 'ProductionCompanynamesfrom db')
      setProductionCompanynames(ProductionCompanyNamesTemp)
      senddata(CompanyEnglishTemp, CompanyTeluguTemp)
      setProductionCompanyname('')
      setProductionCompanynameTelugu('')
      setfilteredProductionCompanyNames([])
    } else {
      setsearchtrue(false)
    }
  }

  const handleProductionCompanynamechange = async value => {
    setProductionCompanyname(value)
    if (value.length <= 3) {
      setfilteredProductionCompanyNames([])
    }

    if (value.length >= 3) {
      try {
        const moviePersonData = await AutoSuggestionsdata(value)
        setAutoSuggestions(moviePersonData)
        const filteredProductionCompanyNames = autoSuggestions
          ? moviePersonData.personHits.map(e => ({ label: e.name_En }))
          : []
        const filteredProductionCompanyNamesTelugu = autoSuggestions
          ? moviePersonData.personHits.map(e => ({ label: e.name_Te }))
          : []
        setfilteredProductionCompanyNames(filteredProductionCompanyNames)
        setfilteredProductionCompanyNamesTelugu(filteredProductionCompanyNamesTelugu)
      } catch (error) {
        setAutoSuggestions([])
        setfilteredProductionCompanyNames([])
        setfilteredProductionCompanyNamesTelugu([])
        console.warn(error)
      }
    }
  }

  const finalfilteredProductionCompanyNames = [...filteredProductionCompanyNames]
  if (ProductionCompanyname.length >= 3) {
    finalfilteredProductionCompanyNames.unshift({ label: `Create ${ProductionCompanyname}` })
  }

  const indication = props.modeUrl
    ? (props.editData[inputField1].length === 0 && inputData[inputField1].length === 0) ||
      props.editData[inputField1] === inputData[inputField1] ||
      props.active[inputField1] === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''

  return (
    <div>
      <Row>
        <Col md={6} xs={12}>
          <div>
            <label>{`${name}_En`}:</label>
            {inputData[inputField1].length >= 1 && (
              <div>
                <Dragdrop
                  name={name}
                  truevalue={props.truevalue}
                  sendtruevalue={props.sendBooleanValueChangeDone}
                  display={inputData[inputField1]}
                  displayte={inputData[inputField2]}
                  namearr={ProductionCompanyname}
                  namearrtel={ProductionCompanynameTelugu}
                  sendname={sendProductionCompanyName}
                  sendnamete={sendProductionCompanyNameTelugu}
                  editmode={'edit'}
                  senddata={senddata}
                  sendsearchtrue={sendsearchtrue}
                  personnames={ProductionCompanyNames}
                  editpersonmode={editMode}
                  sendPersonEditmode={sendEditmode}
                  modeUrl={props.modeUrl}
                  indication={indication}
                />
              </div>
            )}
            {props.modeUrl && (
              <WikipediaCheckbox
                Id={weight}
                field={inputField1}
                active={props.active}
                handleActiveChange={props.handleActiveChange}
              />
            )}
            {searchtrue && (
              <input
                type={'text'}
                className='form-control'
                onChange={e => handleProductionCompanynamechange(e.target.value)}
                value={ProductionCompanyname}
                style={props.modeUrl && indication}
              ></input>
            )}
            {finalfilteredProductionCompanyNames.length >= 1 && searchtrue && (
              <div className='searchfield'>
                {searchtrue &&
                  finalfilteredProductionCompanyNames.map(
                    (ProductionCompanyname, ProductionCompanyIndex) => (
                      <div
                        key={ProductionCompanyIndex}
                        onClick={event => ProductionCompanyset(event)}
                      >
                        <label>{ProductionCompanyname.label}</label>
                      </div>
                    ),
                  )}
              </div>
            )}
            {!searchtrue && (
              <input
                type='text'
                value={ProductionCompanyname}
                className='form-control'
                onChange={event => ProductionCompanyEnglish(event)}
              />
            )}
          </div>
        </Col>
        {(!searchtrue || (inputData[inputField2] && inputData[inputField2].length >= 1)) && (
          <Col md={6} xs={12}>
            <div>
              <label>{`${name}_Te`}:</label>
              <div>
                <div style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid lightgray' }}>
                  {inputData[inputField2].map((e, index) => (
                    <span
                      style={{
                        margin: '5px',
                        border: '1px solid black',
                        padding: '1px',
                        borderRadius: '1rem',
                        fontSize: 'small',
                        width: '95%',
                        overflowWrap: 'anywhere',
                      }}
                      key={index}
                    >
                      {e}
                    </span>
                  ))}
                </div>
              </div>
              {!searchtrue && (
                <input
                  type='text'
                  className='form-control'
                  value={ProductionCompanynameTelugu}
                  style={{ width: '100%' }}
                  onChange={event => ProductionCompanyTelugu(event)}
                />
              )}
            </div>
            {!searchtrue && (
              <button
                style={{ float: 'right' }}
                disabled={!(ProductionCompanyname.length >= 1)}
                type='button'
                onClick={() => submitCompany()}
                className='btn btn-primary'
              >
                ok
              </button>
            )}
          </Col>
        )}
      </Row>
    </div>
  )
}

export default ProductionCompany
